import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { GetGraphByUserId } from '../../../reduxToolkit/Graphs/GraphsApi';
import { toast } from 'react-toastify';
import { DeleteItemsApi } from '../../../reduxToolkit/Commons/CommonsApi';
import { errorMsg } from '../../../Apis/functions';
import DeleteModal from '../../Modals/DeleteModal';
import { TABLES } from '../../../Apis/Tables';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DeleteDashboardModal = ({ show, onHide, userId, dashboardId }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    /**
     * Handles the deletion of a dashboard.
     * Sends a request to delete the dashboard by ID,
     * then refreshes the graph data and closes the modal.
     */
    const handleDelete = () => {
        const table = TABLES.DASHBOARD;
        const body = [dashboardId];

        dispatch(DeleteItemsApi({ tableName: table, body })).then(
            ({
                payload: {
                    data: { success, code },
                },
            }) => {
                if (success) {
                    dispatch(GetGraphByUserId(userId)).then(() => {
                        toast.success(t('has_been_deleted_successfully'));
                        onHide();
                    });
                } else errorMsg(code);
            },
        );
    };

    return (
        <DeleteModal
            show={show}
            onHide={onHide}
            onClickFn={handleDelete}
            data={[dashboardId]}
            title_modal={'delete'}
            element_modal={'dashboard'}
        />
    );
};

export default DeleteDashboardModal;
